////////GHG 1.1 EF
const oneOneSchema = {
  title: "1.1 Direct Emissions from Stationary Combustion",
  cat: "1_1",
  catName: "cat1",
  progressiveOrderSwitch: {
    by: { level: 4, key: "sourceEFName" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source
    {
      key: "emissionFactorTypeId",
      level: 3,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Emission Factor Database Source
    {
      key: "sourceEFName",
      level: 4,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        value: "1_1",
      },
      showIf: { level: 3, key: "emissionFactorTypeId", ne: "2" },
      combineKey: 1,
    },
    ////////Fuel Type
    {
      key: "fuelType1_1",
      level: 5,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "sourceEFName",
      },
      showIf: {
        level: 4,
        key: "sourceEFName",
        notEmpty: true,
      },
      combineKey: 2,
    },
    ////////Emission Factor Name (非自定義)
    {
      key: "emissionFactorId",
      level: 6,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "fuelType1_1",
      },
      showIf: {
        level: 5,
        key: "fuelType1_1",
        notEmpty: true,
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 6,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat1CustomEFDropdownList",
      showIf: {
        level: 3,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default oneOneSchema;
